quoteModule.factory('quoteIntegrationService', ['$http', 'AppSettings', 'commonRESTCallService', 'erateSessionVarsService','$window','$q',
    'rateQuoteRetrievalCoordService', 'commonTLCService',
    function ($http, appSettings, commonRESTCallService, erateSessionVarsService, $window, $q, rateQuoteRetrievalCoordService, commonTLCService) {
    var quoteIntegrationService = {};
    //retrieve the integration data by token
    quoteIntegrationService.getQuoteIntegrationByToken = function(token)
    {
        var deferred = $q.defer();

        var url = appSettings.startSPANQuoteTokenSvcUrl + "/quote-integration/" + token;
        commonRESTCallService.getFromServer(url)
            .success(function gotDataByToken(data, status) {
                deferred.resolve(data);
            })
            .error(function(data, status) {
                deferred.reject(status + ' ' + data);
            })

        return deferred.promise;
    }
    //update the integration data by token
    quoteIntegrationService.setQuoteIntegrationByToken = function(token, quoteIntegrationData)
    {
        var deferred = $q.defer();

        var url = appSettings.startSPANQuoteTokenSvcUrl + "/quote-integration/" + token;
        commonRESTCallService.putToServer(url, quoteIntegrationData)
            .success(function updatedQuoteByToken(data, status) {
                deferred.resolve(data);
            })
            .error(function(data, status) {
                deferred.reject(status + ' ' + data);
            })

        return deferred.promise;
    }
    //send integration data back to the source app (after quotes are saved)
    quoteIntegrationService.signalIntegrationSendToApp = function(token, appName, quoteIntegrationData)
    {
        var deferred = $q.defer();

        var url = appSettings.startSPANQuoteTokenSvcUrl + "/quote-integration/" + token + "/to-app/" + appName;
        commonRESTCallService.putToServer(url, quoteIntegrationData)
            .success(function dataSentToIntegratedApp(data, status) {
                deferred.resolve(data);
            })
            .error(function(data, status) {
                deferred.reject(status + ' ' + data);
            })

        return deferred.promise;
    }
    //capture the integration data to session state (browser local)
    quoteIntegrationService.captureIntegrationData = function(data){
        var deferred = $q.defer();

        $window.sessionStorage.setItem('SESS_INTEGRATION_PREFILL', JSON.stringify(data));
        if (data.productsToQuote && data.productsToQuote.length > 0){
            var foundQuote = false;
            var quoteCount = data.productsToQuote.length;
            var loadQuotePromises = [];
            var encQuotePromises = [];
            for (var i = 0; i < quoteCount; i++){
                var quoteId = null;
                var prodToQuote = data.productsToQuote[i];
                if (prodToQuote && prodToQuote.internalQuoteId != null && prodToQuote.internalQuoteId.length > 0){
                    quoteId = prodToQuote.internalQuoteId;
                    foundQuote = true;
                }
                if (quoteId) {
                    //encrypt the quote ids first
                    var promEncId = commonTLCService.encryptNumeric(quoteId);
                    encQuotePromises.push(promEncId);
                }
            }

            if (!foundQuote)
                deferred.resolve('');
            else{
                $q.all(encQuotePromises)
                .then(
                    function encodedIds(encodedIdRes){
                        for (k=0; encodedIdRes && k < encodedIdRes.length; k++){
                            var promLoadById = rateQuoteRetrievalCoordService.loadQuoteById(encodedIdRes[k]);
                            loadQuotePromises.push(promLoadById);
                        }
                        //now load the quote
                        $q.all(loadQuotePromises)
                            .then(
                            function retrievedQuotes(quotesRetrievedByIdRes){
                                for (j = 0; quotesRetrievedByIdRes && j < quotesRetrievedByIdRes.length; j++){
                                    if (quotesRetrievedByIdRes[j]){
                                        deferred.resolve(quotesRetrievedByIdRes[j].quoteSessionNumber);
                                    }
                                }
                            },
                            function retrievedQuotesErr(err){
                                deferred.reject('');
                            }
                        )
                    }
                )
            }
        }
        else{
            deferred.resolve('');
        }

        return deferred.promise;
    }

    quoteIntegrationService.clearIntegrationData = function(){
        $window.sessionStorage.setItem('SESS_INTEGRATION_PREFILL', '{}');
    }

    quoteIntegrationService.getIntegratedFinancialData = function() {
        var integrationData = JSON.parse($window.sessionStorage.getItem('SESS_INTEGRATION_PREFILL'));
        var finOpt = null;

        if (integrationData.financialDatas && integrationData.financialDatas.length > 0){
            finOpt = integrationData.financialDatas[0];
        }

        return finOpt;
    }

    quoteIntegrationService.getIntegratedCustomerData = function() {
        var integrationData = JSON.parse($window.sessionStorage.getItem('SESS_INTEGRATION_PREFILL'));
        var custData = {};

        if (integrationData.primaryBuyerInfo){
            custData = integrationData.primaryBuyerInfo;
            if (integrationData.coBuyerInfo){

                custData["coBuyerInfo"] = integrationData.coBuyerInfo;
            }
        }
        if (integrationData.businessInfo){
            custData = integrationData.businessInfo;
        }
        return custData;
    }

    quoteIntegrationService.getIntegratedVehicleData = function() {
        var integrationData = JSON.parse($window.sessionStorage.getItem('SESS_INTEGRATION_PREFILL'));
        var vehicleData = null;

        if (integrationData.vehicleInfo){
            vehicleData = integrationData.vehicleInfo;
        }
        return vehicleData;
    }

    quoteIntegrationService.getIntegratedQuotesToContract = function(){
        var deferred = $q.defer();
        var integrationData = JSON.parse($window.sessionStorage.getItem('SESS_INTEGRATION_PREFILL'));
        if (integrationData.productsToQuote && integrationData.productsToQuote.length > 0) {
            var aQuoteId = null;
            integrationData.productsToQuote.forEach(function lookForQuoteId(prodToQuote){
                if (prodToQuote && prodToQuote.internalQuoteId != null && prodToQuote.internalQuoteId.length > 0){
                    aQuoteId = prodToQuote.internalQuoteId;
                }
            });
            if (aQuoteId){
                commonTLCService.encryptNumeric(aQuoteId)
                .then(function(encryptedQuoteId){
                    rateQuoteRetrievalCoordService.loadQuoteById(encryptedQuoteId)
                        .then(
                        function(quoteDat){
                            deferred.resolve(
                                {
                                    quoteScenario: quoteDat.quoteScenarioNumber,
                                    quoteSession: quoteDat.quoteSessionNumber,
                                    allQuoteInfo : angular.copy(integrationData.productsToQuote)
                                }
                            );
                        }
                    );
                });
            }else {
                deferred.resolve(null);
            }
        }
        return deferred.promise;
    }
    //get the saved integration data from session
    quoteIntegrationService.getIntegrationData = function() {
        return JSON.parse($window.sessionStorage.getItem('SESS_INTEGRATION_PREFILL'));
    }
    //get the saved integration data from session
    quoteIntegrationService.setIntegrationData = function(data) {
        return $window.sessionStorage.setItem('SESS_INTEGRATION_PREFILL',JSON.stringify(data));
    }
    //prepare the data we have saved to send back to the integrated application
    quoteIntegrationService.prepDataForIntegrationSubmit = function(customerData, vehicleData, dealData, ratesScenarios, scenariosList){
        var deferred = $q.defer();

        var url = appSettings.startSPANQuoteTokenSvcUrl + "/quote-integration/to-app/template";
        commonRESTCallService.getFromServer(url)
            .success(function prepareIntegrationDataForApp(data, status) {
                var toAppIntegrationData = data;

                var integrationDataIn = quoteIntegrationService.getIntegrationData();

                toAppIntegrationData.dealTransactionId = integrationDataIn.dealTransactionId;
                toAppIntegrationData.dmsDealNumber = integrationDataIn.dmsDealNumber;
                toAppIntegrationData.userName = integrationDataIn.userName;
                toAppIntegrationData.integrationAppName = integrationDataIn.integrationAppName;
                toAppIntegrationData.appDealerID = integrationDataIn.appDealerID;
                toAppIntegrationData.providerCode = integrationDataIn.providerCode;


                toAppIntegrationData.primaryBuyerInfo.firstName = customerData.BuyerInfo.firstName;
                toAppIntegrationData.primaryBuyerInfo.middleName = customerData.BuyerInfo.middleName;
                toAppIntegrationData.primaryBuyerInfo.lastName = customerData.BuyerInfo.lastName;
                toAppIntegrationData.primaryBuyerInfo.email = customerData.BuyerInfo.email;
                toAppIntegrationData.primaryBuyerInfo.address1 = customerData.address1;
                toAppIntegrationData.primaryBuyerInfo.address2 = customerData.address2;
                toAppIntegrationData.primaryBuyerInfo.city = customerData.city;
                toAppIntegrationData.primaryBuyerInfo.state = customerData.state;
                toAppIntegrationData.primaryBuyerInfo.zip = customerData.zip;
                toAppIntegrationData.primaryBuyerInfo.phone = customerData.phone1;
                toAppIntegrationData.coBuyerInfo.firstName = customerData.CoBuyerInfo.firstName;
                toAppIntegrationData.coBuyerInfo.middleName = customerData.CoBuyerInfo.middleName;
                toAppIntegrationData.coBuyerInfo.lastName = customerData.CoBuyerInfo.lastName;
                toAppIntegrationData.coBuyerInfo.email = customerData.CoBuyerInfo.email;
                toAppIntegrationData.businessInfo.businessName = customerData.BusinessInfo.businessName;
                toAppIntegrationData.businessInfo.primaryDriverFirstName = customerData.BusinessInfo.driverFirstName;
                toAppIntegrationData.businessInfo.primaryDriverLastName = customerData.BusinessInfo.driverLastName;
                toAppIntegrationData.businessInfo.address1 = customerData.address1;
                toAppIntegrationData.businessInfo.address2 = customerData.address2;
                toAppIntegrationData.businessInfo.city = customerData.city;
                toAppIntegrationData.businessInfo.state = customerData.state;
                toAppIntegrationData.businessInfo.zip = customerData.zip;
                toAppIntegrationData.businessInfo.phone = customerData.BusinessInfo.phone1;

                toAppIntegrationData.vehicleInfo.vin = vehicleData.vin;
                toAppIntegrationData.vehicleInfo.modelYear = vehicleData.year;
                toAppIntegrationData.vehicleInfo.makeName = vehicleData.makeName;
                toAppIntegrationData.vehicleInfo.modelName = vehicleData.modelName;
                toAppIntegrationData.vehicleInfo.odometer = vehicleData.odometer;
                toAppIntegrationData.dateOfSale = vehicleData.dateOfSale;

                toAppIntegrationData.financialData.daysToFirst = dealData.daysToFirst;
                toAppIntegrationData.financialData.amountFinanced = dealData.amountFinanced ? parseFloat(dealData.amountFinanced) : 0;
                toAppIntegrationData.financialData.financingAPR = dealData.financedRate ? parseFloat(dealData.financedRate) : 0;
                toAppIntegrationData.financialData.sellingPrice = dealData.sellingPrice ? parseFloat(dealData.sellingPrice) : 0;
                toAppIntegrationData.financialData.saleType = dealData.saleType;
                toAppIntegrationData.financialData.financingMonths = dealData.termMonths ? parseInt(dealData.termMonths): 0;
                toAppIntegrationData.financialData.vehicleMSRP = dealData.MSRP ? parseFloat(dealData.MSRP) : 0;

                var cloneScenario = angular.copy(toAppIntegrationData.quoteScenarios[0]);
                var cloneQuotedProd = angular.copy(cloneScenario.productsQuoted[0]);
                cloneScenario.productsQuoted = [];

                toAppIntegrationData.quoteScenarios = [];

                for(var i = 0; i < scenariosList.length; i++){
                    var nxtScenario = angular.copy(cloneScenario);

                    nxtScenario.scenarioCode = scenariosList[i];

                    toAppIntegrationData.quoteScenarios.push(nxtScenario);
                    var firstRate = true;
                    var scenario = scenariosList[i];

                    for (var j=0; j < ratesScenarios[scenario].length; j++){
                        var quotedRate = ratesScenarios[scenario][j];
                        var nxtRate = null;

                        nxtRate = angular.copy(cloneQuotedProd);
                        nxtScenario.productsQuoted.push(nxtRate);

                        nxtRate.internalQuoteId = quotedRate.RatedTerms[0].SavedRateUniqueId;
                        nxtRate.appProductCode = quotedRate.RatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode.toUpperCase();
                        if (quotedRate.BaseNoUpgradeProductRates != null && quotedRate.BaseNoUpgradeProductRates.length > 0)
                            nxtRate.baseProductCode = quotedRate.BaseNoUpgradeProductRates[0].BaseRatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode.toUpperCase();
                        nxtRate.retailPrice = quotedRate.RatedTerms[0].RetailCost;
                        nxtRate.dealerCost = quotedRate.RatedTerms[0].DealerCost;
                        nxtRate.allowModify = quotedRate.RatedTerms[0].CanRetailBeModified;
                        nxtRate.maxRetailAllowed = quotedRate.RatedTerms[0].MaxRetailCostAllowed;
                        nxtRate.productName = quotedRate.RatedProduct.DisplayName;
                        nxtRate.productCoverageName = quotedRate.RatedCoverage!=null ? quotedRate.RatedCoverage.DisplayName : '';
                        nxtRate.productTermName = quotedRate.RatedTerms[0].RatedTerm.DisplayName;
                        nxtRate.productTermMonths = quotedRate.RatedTerms[0].RatedTerm.TermMonths;
                        nxtRate.productTermMiles = quotedRate.RatedTerms[0].RatedTerm.TermMiles;
                        nxtRate.productDeductible = quotedRate.RatedDeductible!=null ? quotedRate.RatedDeductible.DisplayName : '$0';
                    }
                }

                deferred.resolve(toAppIntegrationData);
            })
            .error(function(data, status) {
                deferred.reject(status + ' ' + data);
            })

        return deferred.promise;
    }

    quoteIntegrationService.getProductsToQuote = function () {
        var integrationData = JSON.parse($window.sessionStorage.getItem('SESS_INTEGRATION_PREFILL'));
        var productsToQuote = integrationData.productsToQuote;
        return productsToQuote;
    }

    return quoteIntegrationService;
}]);
